// @flow
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import isEqual from 'react-fast-compare';

type Props = $ReadOnly<{|
    archivedSearch: boolean,
    intl: intlShape,
    sort: string,
    sortOptions: any[],
    sortSelected: Function,
|}>;

type State = $ReadOnly<{|
    selectedSortOption: string,
|}>;

class SearchSort extends Component<Props, State> {
    state = {
        selectedSortOption: this.props.sort,
    };

    shouldComponentUpdate = (nextProps, nextState) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate(prevProps) {
        if (this.props.sort !== prevProps.sort) {
            this.setState({ selectedSortOption: this.props.sort });
        }
    }

    onChangeSortOption = event => {
        const selectedSortOption = event.target.value;
        this.setState({ selectedSortOption });
        this.props.sortSelected(selectedSortOption);
    };

    mapSortOptions = (option, index) => {
        const message = this.props.archivedSearch
            ? this.props.intl.formatMessage({ id: `${option}_sold` })
            : this.props.intl.formatMessage({ id: `${option}_upcoming` });

        return (
            <option key={index} value={option}>
                {message}
            </option>
        );
    };

    render() {
        const { intl, sortOptions } = this.props;

        const { selectedSortOption } = this.state;

        const displaySortOptions = sortOptions.length > 0;

        return displaySortOptions ? (
            <Input
                id="sort"
                label={<FormattedMessage id="search_sort" />}
                labelLeft
                onChange={this.onChangeSortOption}
                placeholder={intl.formatMessage({ id: 'select' })}
                small
                type="select"
                value={selectedSortOption}
                hideSpacer
            >
                {sortOptions.map(this.mapSortOptions)}
            </Input>
        ) : null;
    }
}

export default injectIntl(SearchSort);
